import React from "react";
import RouterLink from './cofig/RouterLink';
import Navbar from './Navbar';
import Footer from './component/footer';
import '../src/App.css';
import Dashboard from "./component/Dashboard/views/Dashboard";
export default function App(props) {

  return (

    <>
    {/* <Navbar /> */}
    <RouterLink />
    {/* <Footer  /> */}

    {/* <Dashboard /> */}
    </>
  );
}